module.exports = __webpack_public_path__ + "img/image_slide5_1.8b1d1ace.png";